import { apiClientes } from "../config/api";
import { Response } from "../interfaces/services/Response";
import { getTokenClientes } from "../Store/storages/AuthenticationStorage";

export const getListaAnexoProntuario = async (): Promise<Response | null> => {
  try {
    const response = await apiClientes.get('/AnexosProntu/GetListaAnexoProntuario', {
      headers: { Authorization: `Bearer ${await getTokenClientes()}` }
    });
    return response;
  } catch (error: any) {
    console.log({ error });
    return error;
  }
};

export const getAnexoProntu = async (idAnexo: string): Promise<Response | null> => {
  try {
    const response = await apiClientes.get(`/AnexosProntu/GetAnexoProntuario?idAnexo=${idAnexo}`, {
      headers: { Authorization: `Bearer ${await getTokenClientes()}` }
    });
    return response;
  } catch (error: any) {
    console.log({ error });
    return error;
  }
};
